import { render, staticRenderFns } from "./ChangeTelephoneModal.vue?vue&type=template&id=7064f97d&"
import script from "./ChangeTelephoneModal.vue?vue&type=script&lang=ts&"
export * from "./ChangeTelephoneModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports